export default {
  controlpacks: {
    title: "Контроль розноски пачок",
    storn: {
      modal: {
        title: "Причина повернення пачки"
      },
      card: {
        selectTypeStornPack: "Виберіть тип сторніровкі пачки",
        chooseReason: "Оберіть причину"
      },
      form: {
        typeStornId: {
          onlyBreakLink: "Тільки розірвати зв'язок між пачкою і платежем",
          stornPack: "Сторнувати пачку і все її квитанції"
        }
      }
    },
    edit: {
      modal: {
        infoPack: "Інформація про пачці",
        compensationDisability: "Компенсація інвалідам по зору",
        socialSupplementInfo: "Інформація про соціальну доплату",
        subsidyInfo: "Інформація про субсидії"
      },
      form: {
        packnumber: {
          title: "Банківський номер пачки"
        },
        datebank: {
          title: "Дата з банку"
        },
        codefirme: {
          title: "Платник"
        },
        accountSender: {
          title: "Р/рахунок платника"
        },
        kindpay: {
          title: "Спосіб оплати"
        },
        quantity: {
          numberSubs: "Кількість абонентів",
          numberReceipts: "Кількість квитанцій"
        },
        countband: {
          numberSheets: "Кількість листів",
          numberCountband: "Кількість бандеролей"
        },
        summa: {
          title: "Сума"
        },
        sumprof: {
          title: "За послуги"
        },
        userid: {
          title: "Оператор"
        }
      }
    },
    receipts: {
      modal: {
        title: "Інформація про пачці"
      },
      form: {
        summa: {
          title: "Сума"
        },
        datebank: {
          title: "Дата з банку"
        },
        quantity: {
          title: "Квитанцій"
        },
        countband: {
          title: "Бандероль"
        },
        reasonname: {
          title: "Причина повернення"
        }
      }
    },
    controlPacksColumn: {
      headers: {
        packs: "Пачка",
        payment: "Платіж"
      }
    },
    packsCountbandColumn: {
      headers: {
        packsCountband: "Бандеролі"
      }
    },
    packsQuantityColumn: {
      headers: {
        packsQuantity: "Квитанції"
      }
    },
    filterStatusOptions: {
      undeployed: "Неразнесенная",
      deployed: "Рознесена",
      invalid: "Помилкова"
    },
    statusPrepareChangeCheck: {
      title: "Сторнування"
    },
    statusAfterQuestion: {
      title: "Сторнування"
    },
    statusModifyPacksReceipts: {
      title: "Зміна"
    },
    statusInfoPack: {
      title: "Успішно",
      pack: "Пачка",
      wasDeliver: "була рознесена"
    },
    stornModalSubmit: {
      returnReason: "Причина повернення",
      allReceiptsDeleted: "Все внесені квитанції обраної пачки будуть видалені",
      continue: "Продовжити",
      confirm: {
        title: "Сторнування"
      }
    }
  }
};
